import { SystemOptionType } from 'data/types';
import { isPtacSelectedSystem } from 'utils/ptac-selected-system';

export type SystemProductImage = {
  key: string;
  type: 'condenser' | 'airHandler' | 'ptacUnit';
  product: { photo: string; name: string };
};

type SeriesDisplayInput = Readonly<{
  name?: string;
  model?: string;
  seriesCode?: string | null;
}>;

export const PRODUCT_IMAGE_BASE =
  'https://images.alpinehomeair.com/300x200/uwm/photos';

export function productImageUrl(photo: string): string {
  return `${PRODUCT_IMAGE_BASE}/${photo}`;
}

function getPtacUnitImages(option: SystemOptionType): SystemProductImage[] {
  return option.configuration.condensers.flatMap((unit) =>
    unit.selectedProduct
      ? [
          {
            key: `ptacUnit-${unit.uniqueId}`,
            type: 'ptacUnit' as const,
            product: unit.selectedProduct
          }
        ]
      : []
  );
}

export function getSystemProductImages(
  option: SystemOptionType
): SystemProductImage[] {
  if (isPtacSelectedSystem(option)) return getPtacUnitImages(option);
  return option.configuration.condensers.flatMap((cond) => [
    ...(cond.selectedProduct
      ? [
          {
            key: `condenser-${cond.uniqueId}`,
            type: 'condenser' as const,
            product: cond.selectedProduct
          }
        ]
      : []),
    ...cond.zones.flatMap((zone) =>
      zone.selectedProduct
        ? [
            {
              key: `airHandler-${zone.uniqueId}`,
              type: 'airHandler' as const,
              product: zone.selectedProduct
            }
          ]
        : []
    )
  ]);
}

export function buildSeriesDisplayName(
  product: SeriesDisplayInput | undefined
): string | undefined {
  if (!product?.name) return undefined;
  if (!product.seriesCode || !product.model) return product.name;
  if (!product.name.endsWith(product.model)) return product.name;
  const manufacturer = product.name.slice(0, -product.model.length).trimEnd();
  return manufacturer
    ? `${manufacturer} ${product.seriesCode}`
    : product.seriesCode;
}
